import {Component, ElementRef, OnInit}   from '@angular/core'
import {Router, ActivatedRoute} from '@angular/router'

import {AuthService, LocalizeService} from '../../insa-services'
import { appConfig } from '../../../insaweb.config'

@Component({
  templateUrl: 'login.component.html'
})
export class LoginComponent{
  username: string;
  password: string;
  submitted: boolean;
  loginText: string = appConfig.loginText;
  passwordChangeVisible: boolean = appConfig.showPasswordChangeButtonOnLogin === undefined ? true : appConfig.showPasswordChangeButtonOnLogin;
  languageChangeVisible: boolean = appConfig.showLanguageChangeButtonOnLogin === undefined ? true : appConfig.showLanguageChangeButtonOnLogin;
  registerVisible: boolean  = appConfig.showRegisterButtonOnLogin === undefined ? false : appConfig.showRegisterButtonOnLogin;
  //custom client title for online portal
  clientTitle: string = appConfig.ClientTitle === undefined ? "Online Portal" : appConfig.ClientTitle;
  languages: Array<any> = [];
  private jwt = 'NO_TOKEN';
  private isRegistrationEnabled = true;

  constructor(private _authService: AuthService, private _router: Router, private _localize: LocalizeService, private _element: ElementRef, private route: ActivatedRoute) {}
  
  ngOnInit(){
    let routeSnapshot = this.route.snapshot;
    //embedded login - use 'accessToken' to gain permissions
    if (routeSnapshot.queryParamMap.has('accessToken')) {
      this.jwt = routeSnapshot.queryParamMap.get('accessToken');
      if (!this._authService.embeddedLogin(this.jwt)) {
        console.log('ERROR: invalid access token provided!')
        // this._router.navigateByUrl('/login'); // error occured
      }
    }
    //external login - OpenID example token, looks for 'jwt' query param and uses that to authenticate
    else if (routeSnapshot.queryParamMap.has('Jwt')) {
      this.jwt = routeSnapshot.queryParamMap.get('Jwt');
      this._authService.login('','',this.jwt);
      this.submitted = true;
      kendo.ui.progress($(".main-loading"), true);  
    }
  }
  
  
  passwordChange(){
    this._router.navigate(['/changePassword']);
  }

  register() {
    this._router.navigate(['/register']);
  }

  onSubmit(form: any): void {
    this._authService.login(form["username"], form["password"]);
    this.submitted = true;
    kendo.ui.progress($(".main-loading"), true);
  }

  selectLanguage(lang) {
    this._localize.setLocale(lang).then(() => {
      this.languages = this._localize.getAvailableLocalesWithFriendlyNames();
      this._localize.applyTranslations(this._element.nativeElement, 'LOOKUP'); // use the lookup table because translation service might not be available
    });
  }

  ngAfterViewInit () {
    this.languages = this._localize.getAvailableLocalesWithFriendlyNames();
    // console.log(this.languages)
    this._localize.applyTranslations(this._element.nativeElement, 'LOOKUP'); // use the lookup table because translation service might not be available
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/login.component.ts